// extracted by mini-css-extract-plugin
export default {"root":"ShareMenu_root__0-8qW","shareButton":"ShareMenu_shareButton__eIEd5","shareDropdown":"ShareMenu_shareDropdown__hJ2i+","copyButton":"ShareMenu_copyButton__dklSe"};